import { Injectable } from '@angular/core';
import { Effect, ofType, Actions } from '@ngrx/effects';
import { OverlayActionType, ToggleOverlayAction } from '../actions/overlay.action';
import { tap } from 'rxjs/operators';
import { NgxSmartModalService } from 'ngx-smart-modal';

/** OverlayEffect */
@Injectable()
export class OverlayEffect {
    /** Effect */
    @Effect({dispatch: false})
    /** overlayToggle */
    public overlayToggle = this.actions.pipe(ofType<ToggleOverlayAction>(OverlayActionType.TOGGLE_OVERLAY), tap(
        ac => {
                this.ngxSmartModalService.getModal(ac.payload.modalName).open();
        },
    ));
    /**
     *
     * @param actions
     * @param ngxSmartModalService
     */
    public constructor (public actions: Actions, private ngxSmartModalService: NgxSmartModalService) { }
}
